import {Vue} from "ui.vue";
import {VuexFavoritesRestClient} from './lib/rest';

/**
 *
 * @package citrus.vuex.favorites
 */
const favorites = {
	namespaced: true,
	state: {
		iBlockId: 0,
		products: []
	},
	actions: {
		clean(store) {
			let iBlockId = store.getters.iBlockId;
			let restClient = new VuexFavoritesRestClient();
			restClient.setIBlockId(iBlockId);

			return restClient.clean().then(() => {
				store.commit('clean');

				Vue.event.$emit('Citrus.Vue.Favorites:refresh');
				BX.onCustomEvent("Citrus.Vue.Favorites:refresh");
			});
		},
		remove(store, productId) {
			if(false === store.dispatch('check', productId)) {
				return false;
			}

			productId = typeof productId !== 'number' ? parseInt(productId) : productId;

			let iBlockId = store.getters.iBlockId;
			let restClient = new VuexFavoritesRestClient(productId, iBlockId);
			return restClient.remove().then(response => {
				if(!response.success)
					return;

				store.commit('removeProduct', response.product);

				Vue.event.$emit('Citrus.Vue.Favorites:refresh');
				BX.onCustomEvent("Citrus.Vue.Favorites:refresh");
			});
		},
		add(store, productId) {
			if(true === store.getters.check(productId)) {
				return false;
			}

			productId = typeof productId !== 'number' ? parseInt(productId) : productId;

			let iBlockId = store.getters.iBlockId;
			let restClient = new VuexFavoritesRestClient(productId, iBlockId);
			return restClient.add().then(result => {
				store.commit('addProduct', result.product);

				Vue.event.$emit('Citrus.Vue.Favorites:add');
				BX.onCustomEvent("Citrus.Vue.Favorites:add");
			});
		},
		check(store, productId) {
			productId = typeof productId !== 'number' ? parseInt(productId) : productId;
			return store.getters.check(productId);
		},
		setData(store, products) {
			let result = products.map((value) => parseInt(value));
			store.commit('loadProducts', result);
		},
		load(store) {
			let iBlockId = store.getters.iBlockId;
			let restClient = new VuexFavoritesRestClient();
			restClient.setIBlockId(iBlockId);

			return restClient.load().then((result) => {
				store.commit('loadProducts', result.products);

				Vue.event.$emit('Citrus.Vue.Favorites:refresh');
				BX.onCustomEvent("Citrus.Vue.Favorites:refresh");
			});
		},
	},
	mutations: {
		clean(state) {
			state.products = [];
		},
		loadProducts(state, products) {
			state.products = products;
		},
		removeProduct(state, id) {
			state.products = state.products.filter(elem => elem !== id);
		},
		addProduct(state, id) {
			state.products.push(id);
		}
	},
	getters: {
		iBlockId: state => state.iBlockId,
		count: state => state.products.length,
		check: state => id => {
			id = typeof id !== 'number' ? parseInt(id) : id;
			return (state.products.indexOf(id) >= 0);
		},
		index: state => id => {
			return state.products.indexOf(id);
		}
	}
};

export {favorites};
